import { gql } from '@apollo/client'

/* eslint-disable import/prefer-default-export */
export const GET_CLIPS = gql`
  query GetClipList($imageType: [String]!,$limit: Int, $language: [String]) {
    clipList(limit: $limit, language: $language) {
        content {
            id
            contentId
            contentType
            language
            titleGroupId
            title
            shortDescription
            imageContentRelationships (
                language: $language
                types: $imageType
            ) {
                type
                image {
                    url
                }
            }
            featureMedia {
                mediaId
                duration
                mediaAssets(mediaAssets: [{ mediaReferenceType: "ms_clip" }]) {
                    id
                    provider
                    providerKey
                    mediaReferenceType
                    language
                    mimeType
                    published
                    videoPlayback {
                        hlsUrl
                        thumbnailUrl
                    }
                }
            }
            contentReferencesFrom(types: ["clip-vert"]) {
                id
                contentReferenceType {
                    type
                }
                contentTo(language: $language) {
                    contentId
                    contentType
                    titleGroupId
                    title
                    path
                    language
                    languageFullText
                    featureMedia {
                        mediaId
                        mediaAssets(mediaAssets: [{ mediaReferenceType: "ms" }]) {
                            provider
                            providerKey
                            mediaReferenceType
                        }
                        contentPolicy {
                            shareAllowed
                            accessCheck {
                                allowed
                                countryAllowed
                                subscriptionsAllowed
                                isFreeAllowed
                            }
                            optionIds
                        }
                    }
                    imageContentRelationships (
                        language: $language
                        types: $imageType
                    ) {
                        type
                        image {
                            url
                        }
                    }
                }
            }
        }
        count
        limit
        offset
    }
}
`
